import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PermissionService } from 'src/app/shared/services/permission.service';

const ROUTE_MODULE_MAP: Record<string, string> = {
  'task-category':  'task-category',
  'task':           'task',
  'checklist-listing': 'checklist-listing',
  'report':         'report',
  'user-list':      'user-list',
  'create-user':    'user-list',
  'pending-approvals': 'user-list',
  'complaint-list': 'complaint-register',
  'complaint-detail': 'complaint-register',
  'raise-complaint': 'complaint-register',
  'complaint-report': 'complaint-report',
  'ticket-list':    'complaint-report',
  'announcement-list':   'announcements',
  'announcement-create': 'announcements',
  'roles':          'roles',
  'role-form':      'roles',
};

export const permissionGuard: CanActivateFn = (route, state) => {
  const router       = inject(Router);
  const permService  = inject(PermissionService);

  // Must be logged in first
  if (localStorage.getItem('isLoggedIn') !== 'true') {
    router.navigate(['/login']);
    return false;
  }

  // Superadmin bypasses all checks
  if (permService.isSuperAdmin) return true;

  // Derive the last meaningful segment of the URL
  const segments = state.url.split('/').filter(Boolean);
  const lastSeg  = segments[segments.length - 1]?.split('?')[0] ?? '';

  const moduleKey = ROUTE_MODULE_MAP[lastSeg];
  if (!moduleKey) return true; // unmapped routes allowed through

  if (!permService.canAccessPanelModule(moduleKey)) {
    // Redirect to first accessible module
    const allowed = permService.allowedPanelModules;
    const fallback = allowed.length > 0
      ? `/dashboard/${moduleKeyToRoute(allowed[0])}`
      : '/login';
    router.navigateByUrl(fallback);
    return false;
  }

  return true;
};

function moduleKeyToRoute(key: string): string {
  const map: Record<string, string> = {
    'task-category': 'task-category',
    'task': 'task',
    'checklist-listing': 'checklist-listing',
    'report': 'report',
    'user-list': 'user-list',
    'complaint-register': 'complaint-list',
    'complaint-report': 'complaint-report',
    'announcements': 'announcement-list',
    'roles': 'roles',
  };
  return map[key] ?? 'task-category';
}
